(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-room-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('room-carousel')) {
    customElements.define('room-carousel', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        if (!this.tabs.length) return;
        this.index = 0;
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = Number(this.dataset.interval) || 5000;
        this.querySelector('[data-room-previous]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-room-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.show(index));
          tab.addEventListener('keydown', event => this.onKeydown(event, index));
        });
        this.addEventListener('pointerdown', event => {
          this.pointerStart = event.clientX;
        });
        this.addEventListener('pointerup', event => {
          if (this.pointerStart === undefined) return;
          const distance = event.clientX - this.pointerStart;
          this.pointerStart = undefined;
          if (Math.abs(distance) < 50) return;
          this.show(this.index + (distance < 0 ? 1 : -1));
        });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.blockSelectHandler = event => {
          const panel = event.target.closest('[data-room-index]');
          if (panel && this.contains(panel)) this.show(Number(panel.dataset.roomIndex), false);
        };
        document.addEventListener('shopify:block:select', this.blockSelectHandler);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('shopify:block:select', this.blockSelectHandler);
      }

      show(nextIndex, restart = true) {
        if (!this.tabs.length) return;
        this.index = (nextIndex + this.tabs.length) % this.tabs.length;
        this.tabs.forEach((tab, index) => {
          const active = index === this.index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, index) => {
          panel.hidden = index !== this.index;
          panel.classList.toggle('is-active', index === this.index);
        });
        this.tabs[this.index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        if (restart) {
          this.stop();
          this.start();
        }
      }

      onKeydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = index - 1;
        if (event.key === 'ArrowRight') nextIndex = index + 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        this.show(nextIndex);
        this.tabs[this.index].focus();
      }

      start() {
        this.stop();
        if (!this.autoplay || this.tabs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = window.setInterval(() => this.show(this.index + 1, false), this.interval);
      }

      stop() {
        window.clearInterval(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
